import React from 'react';
import PropTypes from 'prop-types';

const Error = (props) => {
	const {text, wrapperClassName, className} = props;

	return (
		<div className={wrapperClassName}>
			<span className={className}>{text}</span>
		</div>
	);
};

Error.defaultProps = {
	wrapperClassName: 'has-error',
	className: 'help-block'
};

Error.propTypes = {
	text: PropTypes.string.isRequired,
	wrapperClassName: PropTypes.string,
	className: PropTypes.string
};

export default Error;